import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=0d7beb5c&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7beb5c')) {
      api.createRecord('0d7beb5c', component.options)
    } else {
      api.reload('0d7beb5c', component.options)
    }
    module.hot.accept("./BaseTextarea.vue?vue&type=template&id=0d7beb5c&", function () {
      api.rerender('0d7beb5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/base/BaseTextarea.vue"
export default component.exports